export default "__VITE_ASSET__9rtsez6d__"